































































import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  BAvatar,
  BBadge, BButton, BCard, BCardTitle, BCol,
  BDropdown,
  BDropdownItem, BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BPagination, BRow, BSpinner
} from "bootstrap-vue";
import {VueGoodTable} from 'vue-good-table'
import {VForm} from "@/global";


@Component({
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BInputGroup,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BSpinner
  }
})
export default class Roles extends Vue {
  $refs!: {
    createForm: VForm
  }

  columns = [
    {
      label: 'Name',
      field: 'name',
    },
  ]

  rows: MaintenanceAPI.Roles.Item[] = [];

  async created() {
    await this.getItems();
  }

  async getItems() {
    this.rows = await this.$api.maintenance.roles.GetList();
  }

  async goTo(params) {
    await this.$router.push({
      name: "maintenance-role",
      params: {
        identifier: params.row.id
      }
    })
  }


  // Create Model
  createModel = {
    loading: false,
    name: null,
  }

  async create(bvModalEvt) {
    this.createModel.loading = true;
    bvModalEvt.preventDefault();

    if(!await this.$refs.createForm.validate()) {
      this.createModel.loading = false;
      return;
    }


    const res = await this.$api.maintenance.roles.Create({name: this.createModel.name});
    if(res != null)
      await this.$router.push({
        name: "maintenance-role",
        params: {
          identifier: res.id,
          action: "edit"
        }
      })

    this.createModel.loading = false;
  }

  cancel() {
    this.$refs.createForm.reset();
    this.$set(this, "createModel", {name: null})
  }
}
